//import Splide from '@splidejs/splide';

// Import our default css theme for splide
//import '@splidejs/splide/css';

// This should only be output on the frontend of the site - NOT the editor
//console.log("hello from the frontend.")

// document.addEventListener( 'DOMContentLoaded', () => {

//   // Splide
//   const splideCustom = document.querySelectorAll('.splideCustom')

//   if(!!splideCustom && splideCustom.length > 0){
//     splideCustom.forEach(splideCustom => {
//       // Grab the slide interval and convert it to an integer and milliseconds
//       const interval = parseInt(splideCustom.dataset.interval) * 1000 || 3000

//       new Splide(splideCustom, { pagination: false, perMove: 1,  pauseOnHover: false, interval: interval,
//         perPage: 2,
//         height: 'auto',
//         gap    : '2rem',
//         padding: '5rem',
//           breakpoints: {
//             6000: {
      
//               perPage: 2,
//               gap    : '2rem',
//               padding: '5rem',
//             },
        
//             2000: {
//               perPage: 2,
//               gap    : '2rem',
//               padding: '5rem',
          
//             },
        
//             1200: {
//               perPage: 2,
//               gap    : '2rem',
//               padding: '5rem',
          
//             },
        
//             960: {
//               perPage: 2,
//               gap    : '.7rem',
//               padding: '0.1rem',
       
//               padding: '1.8rem',
//             },
//             820: {
//               perPage: 1,
            
//               gap    : '1.2rem',
//               padding: '1.2rem',
        
//               //gap    : '8rem',
        
//             }
//           },
        
        
//               }).mount()

//     })
//   }
// })

/*
 JS to toggle scroll axis styles
*/
